import { IStepComponentProps } from "@shared/components/form/types";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import { Head } from "@shared/components/head";
import { Text } from "@shared/components/text";
import { ActivityName } from "app/_modules/core/types";
import { useAuth } from "app/auth/hooks/useAuth";

export interface IDrugIntakeInfoStepContext {
  activityName: ActivityName
}

export const DrugIntakeInfoStep = ({ context }: IStepComponentProps<{ administered: boolean }, IDrugIntakeInfoStepContext>) => {
  const { t } = useTranslation();
  const { meData } = useAuth()

  const drug = meData?.current_pathway.drugs.find((drug) => {
    return drug.drug.name === context?.activityName
  })

  return (
    <View className="flex-col gap-4">
      <Head type="h2">{t("drugs.reminder.title")}</Head>
      <View className="p-4 border border-gray-300 rounded-lg">
        <View className="flex-col gap-4">
          <View className="flex-col gap-2">
            <Text className="font-semibold">{drug?.drug.label}</Text>
            <Text>{drug?.drug.dosage}</Text>
          </View>
          <View className="flex-col gap-2">
            <Text className="font-semibold">{t("drugs.reminder.dosage")}</Text>
            <Text>{drug?.dose_quantity}</Text>
          </View>
          <View className="flex-col gap-2">
            <Text className="font-semibold">{t("drugs.reminder.instructions")}</Text>
            <Text>{drug?.note}</Text>
          </View>
        </View>
      </View>
    </View>
  )
}